import { css } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const className = css`
  display: flex;
  flex-shrink: 0;
  margin: auto;
  padding: 0 1rem;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`;
const Collection = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: children
  });
};
export default Collection;
//# sourceMappingURL=Collection.js.map